<button
  class="no-style burger-wrapper"
  [attr.aria-label]="(isSidebarVisible ? 'side-menu.close' : 'side-menu.open') | translate"
  (click)="onSidebarToggle()">
  <div
    class="menu-burger"
    id="menu-bar-close-open">
    @if (isSidebarVisible) {
      <mat-icon
        animate.enter="fade-in"
        animate.leave="fade-out">
        close
      </mat-icon>
    }
    @if (!isSidebarVisible) {
      <mat-icon
        animate.enter="fade-in"
        animate.leave="fade-out">
        menu
      </mat-icon>
    }
  </div>
</button>
<div
  class="components"
  role="menubar"
  [class.sidebar-visible]="isSidebarVisible"
  [class.visible]="isSidebarVisible">
  <!-- Apps -->
  <cosmos-sidebar-menu-item
    role="menuitem"
    [isContentVisible]="selectedMenuItem === titles[0]"
    [header]="titles[0]"
    (toggle)="toggleMenuItem(titles[0])">
    <coin-siemens-energy-coin-apps-overview
      [isLineManager]="$safeNavigationMigration((userDetails$ | async)?.isLineManager)"
      [isHead]="(userDetails$ | async)?.isHead"
      [coinBaseUrl]="environment.customerUrl"></coin-siemens-energy-coin-apps-overview>
  </cosmos-sidebar-menu-item>
</div>
<cosmos-collapsed-bar
  role="menubar"
  [class.sidebar-visible]="isSidebarVisible"
  [titles]="titles"
  [class.visible]="isSidebarVisible"
  (toggleItem)="onSidebarToggle($event)"></cosmos-collapsed-bar>
